import { FETCH_CC } from './types';
import { getConnectCards } from 'services/connect-card.service';

export const getConnectCard = (hash) => ({
  type: FETCH_CC,
  payload: {
    promise: getConnectCards({ hash, load_account: 1 }),
  },
});
